import React from 'react'
import Lottie from 'react-lottie'

import * as animationData from '../../assets/Loading.json'

interface SpinnerProps {
  width: number
  height: number
}

function Spinner(props: SpinnerProps) {
  return (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      isClickToPauseDisabled={true}
      {...props}
    />
  )
}

export default Spinner
